export const FETCH = "FETCH";
export const IDLE = "IDLE";
export const FETCHING = "FETCHING";
export const FETCH_ERROR = "FETCH_ERROR";